import * as React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { cn } from '../lib/utils';
import { ArrowLeft, ArrowRight } from './Icons';
const navigationVariants = cva('inline-flex items-center justify-center rounded-full border transition-all cursor-pointer', {
    variants: {
        variant: {
            default: 'w-10 h-10 border-[#E2E4E5] hover:bg-gray-50',
            arrow: 'w-[65px] h-[65px] opacity-60 hover:opacity-100',
        },
        direction: {
            left: '',
            right: '',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});
const NavigationButton = React.forwardRef(({ className, variant, direction, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';
    return (React.createElement(Comp, { className: cn(navigationVariants({ variant, direction, className })), ref: ref, "aria-label": direction === 'left' ? 'Previous slide' : 'Next slide', ...props }, variant === 'arrow' ? (direction === 'left' ? (React.createElement(ArrowLeft, { className: "h-6 w-6" })) : (React.createElement(ArrowRight, { className: "h-6 w-6" }))) : direction === 'left' ? (React.createElement(ChevronLeft, { className: "h-6 w-6", color: "#31373D" })) : (React.createElement(ChevronRight, { className: "h-6 w-6", color: "#31373D" }))));
});
NavigationButton.displayName = 'NavigationButton';
export { NavigationButton, navigationVariants };
